/* eslint-disable */
import React, { useEffect } from 'react';
import { FaTrash, FaEdit, FaTimes } from 'react-icons/fa';
import './ConfirmModal.css';

const ConfirmModal = ({
  isOpen,
  type = 'delete', // 'delete' | 'edit' | 'warning'
  title,
  message,
  itemName,
  itemType = 'record',
  confirmText,
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onCancel();
      }
    };
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const isDelete = type === 'delete';
  const defaultTitle = isDelete ? 'Confirm Deletion' : 'Confirm Modification';
  const defaultConfirmText = isDelete ? 'Yes, Delete' : 'Yes, Modify';

  return (
    <div className="premium-confirm-overlay" onClick={onCancel}>
      <div 
        className={`premium-confirm-card ${isDelete ? 'type-delete' : 'type-edit'}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {/* Glowing Top Ambient Line */}
        <div className={`confirm-top-glow ${isDelete ? 'glow-red' : 'glow-gold'}`}></div>

        {/* Close Button */}
        <button className="confirm-close-btn" onClick={onCancel} title="Close">
          <FaTimes size={13} />
        </button>

        {/* Modal Icon Badge */}
        <div className="confirm-icon-wrapper">
          <div className={`confirm-icon-badge ${isDelete ? 'badge-delete' : 'badge-edit'}`}>
            {isDelete ? <FaTrash size={22} /> : <FaEdit size={22} />}
          </div>
        </div>

        {/* Modal Title */}
        <h3 className="confirm-modal-title">
          {title || defaultTitle}
        </h3>

        {/* Modal Description */}
        <div className="confirm-modal-desc">
          {message || (
            <>
              Are you sure you want to {isDelete ? 'delete' : 'modify'}
              {itemName ? <> <span className="confirm-item-highlight">"{itemName}"</span></> : ` this ${itemType}`}?
              {isDelete && <div className="confirm-warning-note">This action is permanent and cannot be undone.</div>}
            </>
          )}
        </div>

        {/* Modal Action Buttons */}
        <div className="confirm-actions-row">
          <button 
            type="button" 
            className="confirm-btn-cancel" 
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            type="button" 
            className={`confirm-btn-action ${isDelete ? 'btn-confirm-delete' : 'btn-confirm-edit'}`} 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : (confirmText || defaultConfirmText)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
